import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuToggleOption} from '@Components/contextual-menu/components/contextual-menu-toggle-option';
import {VectorThicknessOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/vector-thickness-option';
import {VectorOutlineColorOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/vector-outline-color-option';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromBorderOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromBorderOfActiveItem';
import {BorderType} from '@PosterWhiteboard/classes/item-border.class';

interface VectorOutlineOptionProps {
  onClickColorOption(): void;
  max?: number
}
export function VectorOutlineOption({...props}: VectorOutlineOptionProps): ReactElement<any> | null {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeItemBorderType = useGetKeyFromBorderOfActiveItem('solidBorderType');
  const activeItemBorderThickness = useGetKeyFromBorderOfActiveItem('solidBorderThickness');


  if (!activeItem || activeItemBorderThickness === undefined) {
    return null;
  }

  if (!activeItem.isVector() && !activeItem.isRectangle() && !activeItem.isLine()) {
    return null;
  }

  const isToggleOn = (): boolean => {
    return activeItemBorderType !== BorderType.NONE && activeItemBorderThickness > 0;
  };

  const onToggle = (): void => {
    void activeItem.updateFromObject({
      border: {
        solidBorderType: isToggleOn() ? BorderType.NONE : BorderType.RECTANGLE_BORDER,
        solidBorderThickness: isToggleOn() ? 0 : 4,
      },
    });
  };

  return (
    <ContextualMenuToggleOption id="vector-outline-toggle-option" label={window.i18next.t('pmwjs_outline')} onClick={onToggle} isChecked={isToggleOn()}>
      {isToggleOn() ? (
        <>
          <VectorOutlineColorOption
            onClickColorOption={(): void => {
              props.onClickColorOption();
            }}
          />
          <VectorThicknessOption min={1} max={props.max} />
        </>
      ) : null}
    </ContextualMenuToggleOption>
  );
}
